<div class="row mt-2">
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="version?.histInfo" label="Grundpfandrechtart">
      {{ version | namenInhaberPfandrechtart }}
    </cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.pfandrechtform | translate" label="Grundpfandrechtform">
    </cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.pfandsumme | betrag" label="Pfandsumme"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="maximalzinsfuss" label="Maximalzinsfuss"></cap-kopfdatenelement>
    <cap-kopfdatenelement
      [histInfo]="version?.histInfo"
      [value]="version?.gesetzlichesPfandrecht?.text | translateName"
      label="GesetzlichesPfandrecht"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.hinweis" label="Hinweis"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" label="ZinsUndAbzahlungsbestimmungen">
      {{ version?.zinsUndAbzahlungsbestimmungen | yesNo }}
    </cap-kopfdatenelement>
  </div>
  <div class="col-md-6 col-sm-12">
    <cap-kopfdatenelement [histInfo]="recht.histInfo" [value]="recht.ereid" label="EREID"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="version?.fremdeId" label="FremdeIdentifikation"></cap-kopfdatenelement>
    <cap-kopfdatenelement [histInfo]="version?.histInfo" [value]="alteIdentifikation" label="AlteIdentifikation"></cap-kopfdatenelement>
    @if (recht.mUrsprung.access != "NONE") {
      <cap-kopfdatenelement [histInfo]="recht.ursprung?.version.histInfo" label="EntstandenAus">
        @if (recht.ursprung && recht.ursprung.art === "PFANDRECHT") {
          <cap-kompakt-grundpfandrecht
            [histInfo]="recht.ursprung.version.histInfo"
            [masterId]="recht.ursprung.rechteId"
            [rechteId]="recht.rechteId"
            [version]="recht.ursprung.version"
            format="GRUNDPFANDRECHT_TYP01">
          </cap-kompakt-grundpfandrecht>
        } @else {
          @if (recht.ursprung) {
            <cap-kompakt-standardrecht
              [histInfo]="recht.ursprung.version.histInfo"
              [recht]="recht.ursprung"
              [textLimit]="200"
              format="STANDARDRECHT_TYP01">
            </cap-kompakt-standardrecht>
          }
        }
      </cap-kopfdatenelement>
    }
    <cap-kopfdatenelement label="ErstelltMit">
      <cap-kompakt-timepoint [item]="version?.histInfo.vonTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
    <cap-kopfdatenelement label="GestrichenMit">
      <cap-kompakt-timepoint [item]="version?.histInfo.bisTimePoint"></cap-kompakt-timepoint>
    </cap-kopfdatenelement>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <cap-kopfdatenelement [histInfo]="version?.histInfo" bodyClass="col-lg-10" label="Bemerkung" labelClass="col-md-2">
      <div class="align-read-more">
        <cap-read-more [limit]="160" [text]="version?.bemerkung"></cap-read-more>
      </div>
    </cap-kopfdatenelement>
    <div class="title-divider mt-md-0"></div>
  </div>
</div>

<cap-bereinigungsmarkierung [recht]="recht" [version]="version"></cap-bereinigungsmarkierung>
